import '../../styles/credits.css';

function Credits() {
    return (
        <div className="credits">
            <span>Fet per <a href="https://x.com/HuguetAndreu/status/1729269729607717369?s=20">Andreu Huguet</a>. Preguntes o dubtes fes-me un missatge a <a href="https://x.com/HuguetAndreu">X.com</a>.</span>
            <nav className="credits-legal-links" aria-label="Enllaços legals">
                <a href="/privacy">Privacitat</a>
                <a href="/terms">Termes</a>
                <a href="/processors">Processadors</a>
                <a href="/aportacions">Aportacions</a>
                <a href="/contact">Contacte</a>
            </nav>
        </div>
    )
}

export default Credits;
